import { useTranslation } from "react-i18next";
import AnimatedModal from "components/layout/motion/AnimatedModal";
import FunctionalButton from "components/layout/FunctionalButton";

interface StartHereConfirmDialogProps {
  visible: boolean;
  waypointName: string;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * Confirm starting mission execution at a selected waypoint (Start Here).
 */
export const StartHereConfirmDialog: React.FC<StartHereConfirmDialogProps> = ({
  visible,
  waypointName,
  onConfirm,
  onCancel,
}) => {
  const { t } = useTranslation(["missions", "common"]);

  return (
    <AnimatedModal
      visible={visible}
      onClose={onCancel}
      className="max-w-md rounded-r10 bg-black100 p-6"
    >
      <h2 className="mb-3 text-h4 font-semibold">{t("dialogs.startHereTitle")}</h2>
      <p className="mb-6 text-h5 text-black40">
        {t("dialogs.startHereBody", { name: waypointName })}
      </p>
      <div className="flex justify-end gap-3">
        <FunctionalButton
          title={t("common:cancel")}
          className="bg-black70 px-4 py-2"
          onClick={onCancel}
        />
        <FunctionalButton
          title={t("dialogs.startHereConfirm")}
          className="bg-primary2 px-4 py-2 hover:bg-primary1"
          onClick={onConfirm}
        />
      </div>
    </AnimatedModal>
  );
};

export default StartHereConfirmDialog;
